import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilitiesService } from './utilities.service';
import { Summary } from '../model/summary';
import { Chargebacks } from '../model/chargebacks';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private readonly baseUri = 'dashboard';

  constructor(private http: HttpClient, private utilities: UtilitiesService) { }

  public fetchAlertsByAlertType(dateFrom: string, dateTo: string) {
    var clientId = this.utilities.clientId;
    const url =
      `${this.baseUri}/fetch-alert-by-alert-types?dateFrom=${dateFrom}&dateTo=${dateTo}&fdcid=${clientId}`;
    return this.http.get<Summary>(url);
  }

  public fetchAlertsByCarBrand(dateFrom: string, dateTo: string) {
    var clientId = this.utilities.clientId;
    const url =
      `${this.baseUri}/fetch-alert-by-car-brands?dateFrom=${dateFrom}&dateTo=${dateTo}&fdcid=${clientId}`;
    return this.http.get<Summary>(url);
  }

  public fetchDashboardCardByType(dateFrom: string, dateTo: string) {
    var clientId = this.utilities.clientId;
    const url =
      `${this.baseUri}/fetch-dashboard-card-by-type?dateFrom=${dateFrom}&dateTo=${dateTo}&fdcid=${clientId}`;
    return this.http.get<Summary>(url);
  }

  public getChargebacksPerPostDate(dateFrom: string, dateTo: string) {
    var clientId = this.utilities.clientId;
    const url =
      `${this.baseUri}/fetch-chargebacks-per-post-date?dateFrom=${dateFrom}&dateTo=${dateTo}&fdcid=${clientId}`;
    return this.http.get<Chargebacks>(url);
  }

  public getChargebacksPerTransactionDate(dateFrom: string, dateTo: string) {
    var clientId = this.utilities.clientId;
    const url =
      `${this.baseUri}/fetch-chargebacks-per-transaction-date?dateFrom=${dateFrom}&dateTo=${dateTo}&fdcid=${clientId}`;
    return this.http.get<Chargebacks>(url);
  }

  public getQuicksightEmbedURL(dashboardId: string) {
    const url =
      `${this.baseUri}/fetch-quicksight-embed-url?&dashboardId=${dashboardId}`;
    return this.http.get<string>(url);
  }

  public getAnonymousEmbedUrl(dashboardId: string, clientId: number, origin: string) {
    const url =
      `${this.baseUri}/fetch-anonymous-embed-url?dashboardId=${dashboardId}&clientId=${clientId}&origin=${encodeURIComponent(origin)}`;
    return this.http.get<{ EmbedUrl: string }>(url);
  }

  public getClientsToAccessDashboardSeller() {
    const url =
      `${this.baseUri}/get-clients-to-access-dashboard-seller`;
    return this.http.get<{message: string, data: Array<{ fdClientId: number}>}>(url);
  }
}
